// Core
import React from "react"
import styled from "styled-components"

const H1 = styled.h1`
  font-family: "Montserrat", sans-serif;
  font-size: 3.4rem;
  font-weight: 600;
  line-height: 31px;

  color: ${({ darkBG }) => (darkBG ? "#ffffff" : "#555555")};

  text-align: ${({ center }) => (center ? "center" : "initial")};
`

export default function Title(props) {
  return <H1 {...props}>{props.children}</H1>
}
